import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Eventos } from '../calendario.component';

@Component({
  selector: 'app-item-agenda-min',
  templateUrl: './item-agenda.component.html',
  styleUrls: ['./item-agenda.component.css'],
})
export class ItemAgendaMinComponent {
  @Input() eventos: Eventos[] = [];
  @Input() day: number = 1;
  hover = false;

  @Output() sendEvento = new EventEmitter<Eventos>();
  eventoClick(ev: Eventos) {
    this.sendEvento.emit(ev);
  }

  isVencida(date: any) {
    const d = new Date(date);
    const today = new Date();
    return d < today;
  }
}
